/** Compresión local antes de enviar; las miniaturas no salen del navegador hasta confirmar. */
export async function prepareReviewPhotoPreview(original: File): Promise<File> {
  if (!['image/jpeg', 'image/png', 'image/webp'].includes(original.type) || original.size > 15 * 1024 * 1024) {
    throw new Error('Elige fotos JPG, PNG o WebP de hasta 15 MB.');
  }
  let bitmap: ImageBitmap;
  try { bitmap = await createImageBitmap(original); }
  catch { throw new Error('No pudimos abrir esa foto. Prueba con otra imagen JPG, PNG o WebP.'); }
  try {
    const scale = Math.min(1, 1600 / Math.max(bitmap.width, bitmap.height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(bitmap.width * scale));
    canvas.height = Math.max(1, Math.round(bitmap.height * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('No pudimos preparar la foto. Inténtalo de nuevo.');
    context.fillStyle = '#ffffff';
    context.fillRect(0, 0, canvas.width, canvas.height);
    context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise<Blob | null>(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.82));
    if (!blob || blob.size > 3 * 1024 * 1024) throw new Error('La foto es demasiado grande. Elige una más pequeña.');
    return new File([blob], 'experiencia.jpg', { type: 'image/jpeg' });
  } finally { bitmap.close(); }
}
